import React from "react";

export default function SpreedlyLoader({ loading }) {
  return (
    <div className={loading ? "text-center" : "hidden"} style={{ height: "2.5em" }}>
      <i className="fa fa-spin fa-spinner" />
    </div>
  );
}
